// UST's register of sites with contaminated soil or suspected contamination
// (Regulation 1400/2020), the same data as kortasja.ust.is "Mengaður
// jarðvegur". Served as GeoJSON from UST's GeoServer, which allows CORS.
const SOIL_WFS_URL =
  "https://gis.ust.is/geoserver/wfs?service=WFS&version=1.1.0&request=GetFeature" +
  "&typeName=INSPIRE:mengadur_jardvegur&outputFormat=application/json&srsName=EPSG:4326";

export const SOIL_SOURCE_URL = "https://kortasja.ust.is/mapview/?app=MENGJ";

export const fetchSoilSites = async () => {
  const response = await fetch(SOIL_WFS_URL);
  if (!response.ok) throw new Error(`UST soil register: ${response.status}`);
  const { features } = await response.json();

  return features
    .filter((f) => f.geometry?.type === "Point")
    .map(({ id, geometry, properties: p }) => ({
      id,
      name: p.heiti,
      type: p.teg_mengunar,
      description: p.lysing,
      areaM2: p.staerd_m2,
      volumeM3: p.staerd_m3,
      category: p.flokkun,
      lat: geometry.coordinates[1],
      lon: geometry.coordinates[0],
    }));
};

const formatNumber = (n) => n.toLocaleString("is-IS");

// "1.000 m² · 15 m³", or null when the size isn't recorded
export const formatSize = ({ areaM2, volumeM3 }) =>
  [
    areaM2 != null && `${formatNumber(areaM2)} m²`,
    volumeM3 != null && `${formatNumber(volumeM3)} m³`,
  ]
    .filter(Boolean)
    .join(" · ") || null;

// UST's own category names; the register doesn't publish what each means
export const categoryLabel = (category) =>
  category == null ? "Unclassified" : `Flokkur ${category}`;
